export const COUNTDOWN_SET = 'COUNTDOWN_SET';

export const countdownSet = (countdown) => ({
  type: COUNTDOWN_SET,
  payload: countdown,
});
